import { earnMixin } from "@mixin/earn";
export default {
  name: "pageEarn",
  mixins: [earnMixin],
  data() {
    return {};
  }
};